var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/ban-ts-comment,import/namespace */
import React from "react";
import * as ReactFeatherIcons from "react-feather";
import * as CustomIcons from "../index";
import FeatherIcons from "../FeatherIcons";
const IconWrapper = (_a) => {
    var { name } = _a, props = __rest(_a, ["name"]);
    // @ts-ignore
    // Typescript cannot validate dynamic namespaces, but with the typing we know it is okay
    if (ReactFeatherIcons[name]) {
        return React.createElement(FeatherIcons, Object.assign({}, props, { name: name }));
    }
    // @ts-ignore
    const CustomIcon = CustomIcons[name];
    return React.createElement(CustomIcon, Object.assign({}, props));
};
export default IconWrapper;
//# sourceMappingURL=IconWrapper.js.map